import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaYoutube, FaPlayCircle, FaUser, FaEye, FaThumbsUp, FaSpinner } from 'react-icons/fa';
import { usePortfolio } from '../context/PortfolioContext';

const YouTube = () => {
  const { portfolioData, loading } = usePortfolio();
  const channels = portfolioData?.youtube || [];
  const [activeTab, setActiveTab] = useState(channels[0]?.id || null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // For now, videos are not in the backend, so just show channel info

  return (
    <section id="youtube" className="py-14 bg-gray-900">
      <motion.h2
        className="section-title text-white mb-12 text-left"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        YouTube Channels & Content
      </motion.h2>
      {loading ? (
        <div className="container flex justify-center items-center">
          <FaSpinner className="animate-spin text-primary text-4xl" />
        </div>
      ) : !channels.length ? (
        <div className="container text-center text-gray-400">
          <FaYoutube className="text-4xl mx-auto mb-4" />
          No YouTube channels available yet.
        </div>
      ) : (
        <div className="container">

          <div className="flex gap-4 mb-8">
            {channels.filter(channel => channel.visible).map(channel => (
              <button
                key={channel.id}
                className={`px-6 py-2 rounded-lg font-medium transition-colors ${activeTab === channel.id ? 'bg-primary text-white' : 'bg-gray-800 text-gray-300 hover:bg-primary/20'}`}
                onClick={() => setActiveTab(channel.id)}
              >
                {channel.name}
              </button>
            ))}
          </div>

          {channels.filter(channel => channel.visible).length > 0 && (
            <div className="bg-gray-800 rounded-lg p-8 flex flex-col md:flex-row gap-8 items-center">
              <img
                src={channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.avatar || '/youtube/default-avatar.svg'}
                alt={channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.name}
                className="w-32 h-32 rounded-full object-cover border-4 border-primary"
              />
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-2">{channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.name}</h3>
                <p className="text-gray-300 mb-2">{channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.description}</p>
                <div className="flex items-center gap-4 text-gray-400 mb-2">
                  <FaUser /> <span>{channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.handle}</span>
                  <FaYoutube /> <span>{channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.subscribers} subscribers</span>
                </div>
                <a
                  href={channels.filter(channel => channel.visible).find(channel => channel.id === activeTab)?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-primary hover:underline mt-2"
                >
                  <FaYoutube /> Visit Channel
                </a>
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default YouTube; 